import {combineReducers} from 'redux';

import players from './players-reducer';
import shots from './shots-reducer';
import stats from './stats-reducer';
import selected from './selections-reducer';

const rootReducer = combineReducers({
  players,
  shots,
  stats,
  selected
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js